import * as lucideReact from 'lucide-react';

import { PropsWithClassName } from '@/types';

type SelectableImageProps = PropsWithClassName<{
  src: string;
  alt?: string;
  selected?: boolean;
  onClick?: () => void;
}>;

export function SelectableImage({
  src,
  alt = '',
  onClick,
  selected,
  className,
}: SelectableImageProps) {
  return (
    <div
      className={`relative w-[63px] h-[63px] rounded-lg border-2 cursor-pointer flex items-center justify-center transition 
      ${selected ? 'border-blue-500' : 'border-gray-300'} ${className}`}
      onClick={onClick}
    >
      <img alt={alt} className="w-full" src={src} />

      {selected && (
        <div className="absolute bottom-1 right-1 bg-blue-500 rounded-full p-1">
          <lucideReact.Check className="w-4 h-4 text-white" />
        </div>
      )}
    </div>
  );
}
